import { createLazyFeature } from './lazy-feature-loader.js';
const loadStripeJsModule = createLazyFeature(() => import('@stripe/stripe-js'), { automaticRecovery: false });

const STRIPE_JS_ORIGIN = 'https://js.stripe.com';
const STRIPE_CHECKOUT_ORIGIN = 'https://checkout.stripe.com';
let stripeJsWarmupRequested = false;
let checkoutWarmupRequested = false;

function ensurePreconnect(origin: string, doc: Document): void {
  const existing = Array.from(doc.head.querySelectorAll<HTMLLinkElement>('link[rel="preconnect"]'))
    .some((link) => link.href === `${origin}/` || link.href === origin);
  if (existing) return;
  const link = doc.createElement('link');
  link.rel = 'preconnect';
  link.href = origin;
  link.crossOrigin = 'anonymous';
  doc.head.appendChild(link);
}

/** Warm only after a paid surface is visible, so ordinary visitors do not contact Stripe. */
export function warmCheckout(doc: Document = document): void {
  if ('window' in globalThis && window.drawOnAMapNative) return;
  checkoutWarmupRequested = true;
  ensurePreconnect(STRIPE_CHECKOUT_ORIGIN, doc);
  ensurePreconnect(STRIPE_JS_ORIGIN, doc);
  if (stripeJsWarmupRequested) return;
  stripeJsWarmupRequested = true;
  void loadStripeJsModule().catch(() => {
    stripeJsWarmupRequested = false;
  });
}

export function wasCheckoutWarmupRequested(): boolean {
  return checkoutWarmupRequested;
}

export function checkoutDurationMs(value: number): string {
  return String(Math.min(9_999_999, Math.max(0, Math.round(value))));
}
